export const memberType = {
  authorized: {
    key: 'AUTHORIZED',
    label: 'Authorized Members',
  },
  unique: {
    key: 'UNIQUE',
    label: 'Unique Registered Members',
  },
  registered: {
    key: 'REGISTERED',
    label: 'Registered Members',
  },
};

export const memberTypeKeys = Object.keys(memberType);
export const memberTypeEntries = Object.entries(memberType);
export const memberTypeValues = Object.values(memberType);

export const allMemberStatusType = { value: 'ALL', text: 'ALL' };
export const memberStatusType = {
  enabled: { value: 'ENABLED', text: 'ENABLED' },
  disabled: { value: 'DISABLED', text: 'DISABLED' },
};

export const memberStatusTypesWithAll = [
  allMemberStatusType,
  ...Object.values(memberStatusType),
];
export const memberStatusTypes = Object.values(memberStatusType);
